import parseISO from 'date-fns/parseISO';

export default function isDateIsInTheFuture(isoDateString) {
  return parseISO(isoDateString) > new Date();
}
